query BIMClass(
    $id: ID!
) {
    bimClass(
        id: $id
        tag: "latest"
    ) {
        id

        data {
            name(language: "en") {
                text
            }
        }
    }
}
